import { render, staticRenderFns } from "./TranslatorPriceList.vue?vue&type=template&id=312bcfdd&"
import script from "./TranslatorPriceList.vue?vue&type=script&lang=js&"
export * from "./TranslatorPriceList.vue?vue&type=script&lang=js&"
import style0 from "./TranslatorPriceList.vue?vue&type=style&index=0&id=312bcfdd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports